import { jsx, jsxs } from 'react/jsx-runtime';
import { Image } from '@fabric-app/ui/components/Image';
import { Spinner } from '@fabric-app/ui/components/Spinner';
import { NodeViewWrapper } from '@tiptap/react';
import { useState, useMemo, useEffect } from 'react';
import { styled } from 'styled-components';

const Wrapper = styled(NodeViewWrapper).withConfig({
  displayName: "EmbedComponent__Wrapper",
  componentId: "sc-bc1c6a7f-0"
})([
  `display:block;position:relative;`
]);
const Embed = styled.div.withConfig({
  displayName: "EmbedComponent__Embed",
  componentId: "sc-bc1c6a7f-1"
})([
  `display:inline-block;max-width:100%;white-space:normal;outline-width:0px;outline-offset:0px;outline-color:transparent;img,[data-img-failure]{object-fit:contain;}&[data-loading='true']{img,[data-img-failure]{opacity:0.3;}}.ProseMirror-selectednode & img,.ProseMirror-selectednode & [data-img-failure]{outline:2px solid rgba(var(--color-primary),0.3);}`
]);
const StyledSpinner = styled(Spinner).withConfig({
  displayName: "EmbedComponent__StyledSpinner",
  componentId: "sc-bc1c6a7f-2"
})([
  `position:absolute;`
]);
const YjsCursor = styled.span.withConfig({
  displayName: "EmbedComponent__YjsCursor",
  componentId: "sc-bc1c6a7f-3"
})([
  `position:absolute;top:0;left:0;.ProseMirror-yjs-selection &{outline:3px solid var(--yjs-cursor-color);outline-offset:2px;}`
]);
const EmbedComponent = ({ node }) => {
  const { src, alt, mimeType, title, width, height, loading } = node.attrs;
  const [ref, setRef] = useState(null);
  const element = useMemo(() => {
    if (!src) return null;
    if (mimeType?.startsWith("image/")) {
      return /* @__PURE__ */ jsx(Image, {
        ref: setRef,
        src,
        alt: alt ?? "",
        title: title ?? "",
        width: width ?? "auto",
        height: height ?? void 0,
        "data-resizeable": true
      });
    }
  }, [
    mimeType,
    src,
    alt,
    title,
    width,
    height
  ]);
  const [spinnerPosition, setSpinnerPosition] = useState({
    x: 0,
    y: 0
  });
  const [imageSize, setImageSize] = useState({
    width: 0,
    height: 0
  });
  useEffect(() => {
    if (!ref) return;
    const updatePosition = () => {
      const rect = ref.getBoundingClientRect();
      setSpinnerPosition({
        x: rect.width / 2 - 16,
        y: rect.height / 2 - 16
      });
      setImageSize({
        width: rect.width,
        height: rect.height
      });
    };
    updatePosition();
    const observer = new ResizeObserver(updatePosition);
    observer.observe(ref);
    return () => {
      observer.disconnect();
    };
  }, [
    ref
  ]);
  return /* @__PURE__ */ jsx(Wrapper, {
    children: /* @__PURE__ */ jsxs(Embed, {
      "data-loading": loading,
      draggable: true,
      "data-drag-handle": true,
      children: [
        element,
        loading && element && ref && spinnerPosition.x > 0 && spinnerPosition.y > 0 && /* @__PURE__ */ jsx(StyledSpinner, {
          size: 32,
          thickness: 4,
          style: {
            position: "absolute",
            top: spinnerPosition.y,
            left: spinnerPosition.x
          }
        }),
        /* @__PURE__ */ jsx(YjsCursor, {
          style: {
            width: `${imageSize.width}px`,
            height: `${imageSize.height}px`
          }
        })
      ]
    })
  });
};

export { EmbedComponent as default };
//# sourceMappingURL=EmbedComponent.js.map
